import { List, ListItem, ListItemText } from '@material-ui/core';
import { isSameDay } from 'date-fns';
import React from 'react';

import { CalendarPickerDateRange, CalendarPickerDefinedRange } from '../calendarPicker.types';

type Props = {
  setRange: (range: CalendarPickerDateRange) => void;
  selectedRange: CalendarPickerDateRange;
  ranges: CalendarPickerDefinedRange[];
};

const isSameRange = (first: CalendarPickerDateRange, second: CalendarPickerDateRange) => {
  const { startDate: fStart, endDate: fEnd } = first;
  const { startDate: sStart, endDate: sEnd } = second;
  if (fStart && sStart && fEnd && sEnd) {
    return isSameDay(fStart, sStart) && isSameDay(fEnd, sEnd);
  }
  return false;
};

const CalendarPickerDefinedRanges: React.FC<Props> = (props) => {
  return (
    <List>
      {props.ranges.map((range, idx) => (
        <ListItem button key={idx} onClick={() => props.setRange(range)}>
          <ListItemText
            primaryTypographyProps={{
              variant: 'body2',
              style: {
                fontWeight: isSameRange(range, props.selectedRange) ? 'bold' : 'normal',
              },
            }}
          >
            {range.label}
          </ListItemText>
        </ListItem>
      ))}
    </List>
  );
};

export default CalendarPickerDefinedRanges;
